<template>
	<div class="Box">
		<!-- <div class="Menu">
			<ul>
				<li class="menuText" @click="Menuscroll(1)">声音制作</li>
				<li class="menuText" @click="Menuscroll(2)">视觉效果</li>
				<li class="menuText" @click="Menuscroll(3)">调光调色</li>
				<li class="menuText" @click="Menuscroll(4)">数据管理</li>
				<li class="menuText" @click="Menuscroll(5)">包装服务</li>
				<li class="menuText" @click="Menuscroll(6)">后期统筹</li>
			</ul>
		</div> -->
		<!-- 声音制作 -->
		<div v-for="(flow,index) in flow">
			<!-- 标题 -->
			<div class="scrollheight title" >
				<template>
					<div class="bgimg" v-if="index==0">
						<img src="../assets/img/ll01.png" alt="">
					</div>
					<div class="bgimg" v-if="index==1">
						<img src="../assets/img/ll02.png" alt="">
					</div>
					<div class="bgimg" v-if="index==2">
						<img src="../assets/img/ll03.png" alt="">
					</div>
					<div class="bgimg" v-if="index==3">
						<img src="../assets/img/ll04.png" alt="">
					</div>
					<div class="bgimg" v-if="index==4">
						<img src="../assets/img/ll05.png" alt="">
					</div>
					<div class="bgimg" v-if="index==5">
						<img src="../assets/img/ll06.png" alt="">
					</div>
					<div class="text" @mouseenter="titleEnter($event)" @mouseleave="titleLeave($event)">
						<p class="name">{{flow.title}}</p>
						<p class="english">{{flow.introduction}}</p>
					</div>
				</template>
			</div>
			<div class="division"></div>
			<!-- 内容 -->
			<div class="content">
				<template>
					<!-- 文字 -->
					<div class="content_text" v-html="flow.detail"> {{flow.detail}}
					</div>
					<!-- 轮播 -->
					<div class="content_banner" v-if="index==0">
						<swiper ref="mySwiper" :options="swiperOptionsOne" class="content_box">
							<swiper-slide v-for="imgList in flow.imgList">
								<div class="content_item"><img :src="imgList.pic" alt=""></div>
							</swiper-slide>
						</swiper>
						<div class="btn left"><img src="../assets/img/left.png"></div>
						<div class="btn right"><img src="../assets/img/right.png"></div>
					</div>
					<div class="content_banner" v-if="index==1">
						<swiper ref="mySwiper" :options="swiperOptionsTwo" class="content_box">
							<swiper-slide v-for="imgList in flow.imgList">
								<div class="content_item"><img :src="imgList.pic" alt=""></div>
							</swiper-slide>
						</swiper>
						<div class="btn left2"><img src="../assets/img/left.png"></div>
						<div class="btn right2"><img src="../assets/img/right.png"></div>
					</div>
					<div class="content_banner" v-if="index==2">
						<swiper ref="mySwiper" :options="swiperOptionsThree" class="content_box">
							<swiper-slide v-for="imgList in flow.imgList">
								<div class="content_item"><img :src="imgList.pic" alt=""></div>
							</swiper-slide>
						</swiper>
						<div class="btn left3"><img src="../assets/img/left.png"></div>
						<div class="btn right3"><img src="../assets/img/right.png"></div>
					</div>
					<div class="content_banner" v-if="index==3">
						<swiper ref="mySwiper" :options="swiperOptionsFour" class="content_box">
							<swiper-slide v-for="imgList in flow.imgList">
								<div class="content_item"><img :src="imgList.pic" alt=""></div>
							</swiper-slide>
						</swiper>
						<div class="btn left4"><img src="../assets/img/left.png"></div>
						<div class="btn right4"><img src="../assets/img/right.png"></div>
					</div>
					<div class="content_banner" v-if="index==4">
						<swiper ref="mySwiper" :options="swiperOptionsFive" class="content_box">
							<swiper-slide v-for="imgList in flow.imgList">
								<div class="content_item"><img :src="imgList.pic" alt=""></div>
							</swiper-slide>
						</swiper>
						<div class="btn left5"><img src="../assets/img/left.png"></div>
						<div class="btn right5"><img src="../assets/img/right.png"></div>
					</div>
					<div class="content_banner" v-if="index==5">
						<swiper ref="mySwiper" :options="swiperOptionsSix" class="content_box">
							<swiper-slide v-for="imgList in flow.imgList">
								<div class="content_item"><img :src="imgList.pic" alt=""></div>
							</swiper-slide>
						</swiper>
						<div class="btn left6"><img src="../assets/img/left.png"></div>
						<div class="btn right6"><img src="../assets/img/right.png"></div>
					</div>
					<!-- 作品展示 -->
					<div class="work">
						<div class="work_title">作品展示</div>
						<div class="workGoods">
							<div class="good" v-for="productionList in flow.productionList">
								<div class="goodImg">
									<img :src="productionList.pic" alt="">
								</div>
								<div class="goodTitle">{{productionList.name}}</div>
							</div>
						</div>
					</div>

				</template>
			</div>

		</div>

	</div>
</template>

<script>
	import {
		Swiper,
		SwiperSlide,
		directive
	} from 'vue-awesome-swiper'
	export default {
		name: 'later',
		components: {
			Swiper,
			SwiperSlide
		},
		directives: {
			swiper: directive
		},
		data() {
			return {
				swiperOptionsOne: {
					pagination: {
						el: '.swiper-pagination',
					},
					navigation: {
						nextEl: '.right',
						prevEl: '.left',
					},
					slidesPerView: 3, //页面可视数（网格）
				},
				swiperOptionsTwo: {
					pagination: {
						el: '.swiper-pagination',
					},
					navigation: {
						nextEl: '.right2',
						prevEl: '.left2',
					},
					slidesPerView: 3, //页面可视数（网格）
				},

				swiperOptionsThree: {
					pagination: {
						el: '.swiper-pagination',
					},
					navigation: {
						nextEl: '.right3',
						prevEl: '.left3',
					},
					slidesPerView: 3, //页面可视数（网格）
				},
				swiperOptionsFour: {
					pagination: {
						el: '.swiper-pagination',
					},
					navigation: {
						nextEl: '.right4',
						prevEl: '.left4',
					},
					slidesPerView: 3, //页面可视数（网格）
				},
				swiperOptionsFive: {
					pagination: {
						el: '.swiper-pagination',
					},
					navigation: {
						nextEl: '.right5',
						prevEl: '.left5',
					},
					slidesPerView: 3, //页面可视数（网格）
				},
				swiperOptionsSix: {
					pagination: {
						el: '.swiper-pagination',
					},
					navigation: {
						nextEl: '.right6',
						prevEl: '.left6',
					},
					slidesPerView: 3, //页面可视数（网格）
				},
				flow:[{
					title:""
				}],
				heightsc: [],
				queryNum: "", //监听当前路由是否发生变化
			}
		},
		watch: {
			$route: {
				handler() {
					this.queryNum = this.$route.query.num;
					// this.getDetail();
					//深度监听，同时也可监听到param参数变化
				},
				deep: true,
			},
			queryNum(newValue, old) {
				if (newValue != old) {
					console.log("页面的值由" + old + "变为" + newValue)
					this.indexscroll(newValue)
					// if(newValue==11){
					// 	this.getinfo()
					// }else if(newValue==12){
					// 	this.getEnvironment()
					// }else if(newValue==13){
					// 	this.getContent()
					// }
				}
			}
		},
		methods: {
			//鼠标移入标题
			titleEnter(e){
				let bgimg = e.target.previousElementSibling 
				bgimg.style.transform = 'scale(1.1,1.1)'
				bgimg.style.transitionDuration="1s"
			},
			//鼠标移出标题
			titleLeave(e){
				let bgimg = e.target.previousElementSibling 
				bgimg.style.transform = 'scale(1,1)'
				bgimg.style.transitionDuration="1s"
			},
			//获取后期全流程
			getFolw() {
				this.$api.get(this.$httpApi + this.$path.INDEX_FLOW).then(res => {
					res.data.data.forEach((ele, index) => {
						ele.productionList = ele.productionList.slice(0, 4)
					})
					this.flow = res.data.data;
					this.$nextTick(() => {
						let height = document.querySelectorAll('.scrollheight')
						console.log("当前页面的高度", height)
						height.forEach(ele => {
							this.heightsc.push(ele.offsetTop)
						})
						if(this.$route.query.index){
							this.indexscroll(this.$route.query.index)
						}
						if(this.$route.query.num){
							this.indexscroll(this.$route.query.num)
						}
					})

				}).catch(err => {})
			},
			//设置首页模块部分滚动条高度
			indexscroll(index) {
				let _this = this;
				//首先获取
				if (index == 0 || index == 21) {
					setTimeout(function() {
						document.body.scrollTop = _this.heightsc[0]
						document.documentElement.scrollTop = _this.heightsc[0]
					}, 100);
				} else if (index == 1 || index == 22) {
					setTimeout(function() {
						document.body.scrollTop = _this.heightsc[1]
						document.documentElement.scrollTop = _this.heightsc[1]
					}, 100);
				} else if (index == 2 || index == 23) {
					setTimeout(function() {
						document.body.scrollTop = _this.heightsc[2]
						document.documentElement.scrollTop = _this.heightsc[2]
					}, 100);
				} else if (index == 3 || index == 24) {
					setTimeout(function() {
						document.body.scrollTop = _this.heightsc[3]
						document.documentElement.scrollTop = _this.heightsc[3]
					}, 100);
				} else if (index == 4 || index == 25) {
					setTimeout(function() {
						document.body.scrollTop = _this.heightsc[4]
						document.documentElement.scrollTop = _this.heightsc[4]
					}, 100);
				} else if (index == 5 || index == 26) {
					setTimeout(function() {
						document.body.scrollTop = _this.heightsc[5]
						document.documentElement.scrollTop = _this.heightsc[5]
					}, 100);
				}
			},
			//滚动到固定页面
			Menuscroll(value){
				let _this = this;
				if(value==1){
					document.body.scrollTop = _this.heightsc[0]
					document.documentElement.scrollTop = _this.heightsc[0]
				}else if(value==2){
					document.body.scrollTop = _this.heightsc[1]
					document.documentElement.scrollTop = _this.heightsc[1]
				}else if(value==3){
					document.body.scrollTop = _this.heightsc[2]
					document.documentElement.scrollTop = _this.heightsc[2]
				}else if(value==4){
					document.body.scrollTop = _this.heightsc[3]
					document.documentElement.scrollTop = _this.heightsc[3]
				}else if(value==5){
					document.body.scrollTop = _this.heightsc[4]
					document.documentElement.scrollTop = _this.heightsc[4]
				}else if(value==6){
					document.body.scrollTop = _this.heightsc[5]
					document.documentElement.scrollTop = _this.heightsc[5]
				}
			},
		},
		mounted() {
			this.getFolw();
		}
	}
</script>

<style scoped>
	.Box {
		width: 19.20rem;
		height: auto;
	}

	.scrollheight {
		width: 100%;
		height: 20.71rem;
	}
    /* 菜单栏 */
    .Menu {
    	width: 100%;
    	height: 0.4rem;
    	background-color: #05060a;
    	line-height: 0.20rem;
    	padding-left: 5.10rem;
    	box-sizing: border-box;
    }
    .menuText{
    	color: #ffffff;
    	font-size: 0.18rem;
    	float: left;
    	margin-right: 1rem;
		cursor: pointer;
    } 
	/* 标题开始 */
	.title {
		width: 100%;
		height: 3.40rem;
		padding: 0 1.4rem;
		box-sizing: border-box;
		background-color: #0F0F0F;
		position: relative;
		/* border-bottom: 0.01rem solid #666666; */
	}

	.bgimg {
		width: 2.97rem;
		height: 2.69rem;
		position: absolute;
		left: 1.32rem;
		bottom: 0.25rem;
	}

	.bgimg img {
		/* width: 100%; */
		height: 100%;
	}

	.text {
		min-width: 4.80rem;
		height: 2.69rem;
		position: absolute;
		left: 1.4rem;
		bottom: 0.15rem;
		z-index: 2;
	}
    .text:hover{
		cursor: pointer;
	}
	.name {
		color: #FFFFFF;
		font-size: 0.64rem;
		text-align: left;
		margin-top: 0.74rem;
		line-height: 0.50rem;
		font-weight: 500;
		letter-spacing: 0.08rem
	}

	.english {
		color: #FFFFFF;
		font-size: 0.21rem;
		line-height: 0.30rem;
		font-weight: 300;
		text-align: left;
		margin-top: 0.44rem;
		letter-spacing: 0.03rem
	}

	.det {
		color: #d5d5d5;
		font-size: 0.14rem;
		line-height: 0.20rem;
		position: absolute;
		bottom: 0;
		left: 0;
	}

	/* 标题结束 */
	
	/* 渐变线条 */
	.division{
		width: 90%;
		height: 0.02rem;
		margin: 0 auto;
		background-image: linear-gradient(to right,#969696, #1b1b1b)
	}
	
	/* 内容开始 */
	.content {
		width: 100%;
		/* height: 1000rem; */
		/* height: 17.31rem; */
		background-color: #0F0F0F;
		padding: 0.60rem 1.40rem;
		box-sizing: border-box;
		/* border-bottom: 0.01rem solid #666666; */
	}

	.content_text {
		width: 100%;
		font-size: 0.18rem;
		line-height: 0.36rem;
		color: #e7e7e7;
		text-align: left;
		/* padding: 0.24rem 0; */
		padding-bottom: 0.3rem;
		font-weight: 300;
		text-align: justify;
	}

	/* 轮播 */
	.content_banner {
		width: 100%;
		height: 4.24rem;
		margin: 0.20rem 0;
		padding: 0 0.65rem;
		box-sizing: border-box;
		position: relative;
	}

	.content_box {
		width: 100%;
		height: 100%;
	}

	.content_item {
		width: 4.96rem;
		height: 4.24rem;
		margin-right: 0.13rem;
	}

	.content_item img {
		width: 100%;
		height: 100%;
	}

	.content_item:last-child {
		margin: 0;
	}

	.btn {
		width: 0.31rem;
		height: 0.57rem;
		cursor: pointer;
		outline: none;
	}

	.left,
	.left2,
	.left3,
	.left4,
	.left5,
	.left6 {
		position: absolute;
		left: 0;
		top: 1.71rem;
	}

	.right,
	.right2,
	.right3,
	.right4,
	.right5,
	.right6 {
		position: absolute;
		right: 0;
		top: 1.71rem;
	}

	.btn img {
		width: 100%;
		height: 100%;
		display: block;
	}

	/* 作品展示 */
	.work {
		width: 100%;
		height: 6.80rem;
	}

	.work_title {
		width: 100%;
		height: 1.00rem;
		color: #FFFFFF;
		font-size: 0.32rem;
		text-align: left;
		line-height: 1.00rem;
	}

	.workGoods {
		width: 100%;
		height: 6.10rem;
		display: flex;
		justify-content: space-between;
		padding: 0.20rem 0;
		box-sizing: border-box;

	}

	.good {
		width: 3.09rem;
		height: 5.50rem;
	}

	.goodImg {
		width: 3.09rem;
		height: 4.31rem;
		margin-bottom: 0.95rem;
	}

	.goodImg img {
		width: 100%;
		height: 100%;
	}

	.goodTitle {
		width: 100%;
		height: 0.24rem;
		font-size: 0.2rem;
		color: #ffffff;
		text-align: center;
		line-height: 0.24rem;
		font-weight: 600;
		letter-spacing: 0.02rem;
	}

	/* 内容结束 */
</style>



// WEBPACK FOOTER //
// src/pages/later.vue